import React, { useState } from "react";
import ExclamationCircleIcon from "@heroicons/react/24/outline/ExclamationCircleIcon";
import toast from "react-hot-toast";
import { useCandidateWithApplicationsQuery } from "../../graphql/generated/graphql";
import QuestionnairesModal from "../Modal/QuestionnairesModal";
import QuestionnairesSkeleton from "../Skeletons/QuestionnairesSkeleton";
import CardModal from "../Modal/CardModal";

interface QuestionnairesCardProps {
  photo: string;
  name: string;
  job: string;
  resumeUrl?: string;
  id: number;
}

const Questionnaires: React.FC<QuestionnairesCardProps> = ({
  photo,
  name,
  job,
  resumeUrl,
  id,
}) => {
  const [open, setOpen] = useState(false);

  const { data, loading, error } = useCandidateWithApplicationsQuery({
    variables: { id },
  });

  const questionnaires =
    data?.candidate?.questionnaires.nodes.map((questionnaire) => ({
      title: questionnaire.translations.nodes[0]?.title || "",
      questions: questionnaire.candidateQuestions.nodes.map((question) => ({
        id: question.id,
        questionValue: question.question?.translations.nodes[0]?.title || "",
        answer: question.textValue || "",
      })),
    })) || [];
  const downloadResume = () => {
    if (!resumeUrl) {
      toast.error("کاندید مورد نظر فاقد رزومه می باشد", {
        duration: 3000,
        position: "top-center",
      });
      return;
    }
    const link = document.createElement("a");
    link.href = resumeUrl;
    link.target = "_blank";
    link.setAttribute("download", `${name}-Resume`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDocumentsClick = () => {
    toast(
      <div className="flex items-center gap-2">
        <ExclamationCircleIcon className="h-6 w-6 text-green-700" />
        <span>این بخش به زودی فعال می شود</span>
      </div>,
      {
        duration: 3000,
        position: "top-center",
      }
    );
  };

  const handleDetailsClick = () => {
    if (questionnaires.length === 0) {
      toast("اطلاعاتی برای نمایش وجود ندارد !", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <div className="flex flex-col mx-auto">
      <div className="m-4">
        <h1 className="text-xl font-bold mx-2">{name}</h1>
        <p className="text-lg font-normal text-gray2 mx-2 my-1">{job}</p>
      </div>

      <div className="w-full flex flex-row-2 justify-between items-center gap-5">
        <div className="w-1/2 h-28 sm:h-40 rounded-2xl shadow-md shadow-slate-200 mx-6 border">
          <img
            alt="Candidate"
            src={photo}
            className="rounded-2xl w-full h-full m-auto p-0"
          />
        </div>
        <div
          onClick={handleDetailsClick}
          className="flex h-28 sm:h-40 w-1/2 flex-col mx-6 border rounded-2xl justify-between shadow-sm shadow-slate-200 cursor-pointer"
        >
          <h1 className="text-lg my-auto text-gray2 justify-center text-center leading-7 font-bold">
            نمایش <br />
            توضیحات
          </h1>
        </div>
      </div>

      <div className="w-full flex border-b py-4 gap-5">
        <button
          className="w-1/2 mx-6 border text-center border-slate-300 rounded-md shadow py-3 font-semibold bg-gray-100"
          onClick={downloadResume}
        >
          رزومه
        </button>
        <button
          className="w-1/2 mx-6 border text-center border-slate-300 rounded-md shadow py-3 font-semibold bg-gray-100"
          onClick={handleDocumentsClick}
        >
          مدارک
        </button>
      </div>

      <div>
        {loading ? (
          <QuestionnairesSkeleton />
        ) : error ? (
          <p>Error: {error.message}</p>
        ) : (
          questionnaires.length > 0 && (
            <CardModal open={open} setOpen={setOpen} request={undefined}>
              <QuestionnairesModal questionnaires={questionnaires} />
            </CardModal>
          )
        )}
      </div>
    </div>
  );
};

export default Questionnaires;
